import { grey, red } from "@mui/material/colors";

const styles = {
  dialog: {
    borderRadius: "16px",
  },
  title: {
    textAlign: "center",
    fontWeight: "bold",
    color: grey[800],
    marginBottom: 5,
  },
  subtitle: {
    textAlign: "center",
    color: grey[800],
    marginBottom: 16,
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    padding: 0,
    marginTop: 26,
    gap: 12,
  },
  cancelButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    color: red["A400"],
    backgroundColor: red["50"],
  },
  circularProgress: {
    color: "white",
  },
  activeButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: red["A400"],
    color: "white",
    "&:hover": {
      backgroundColor: red["A700"],
    },
  },
  inactiveButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: grey[500],
    color: grey[300],
  },
  mainContainer: {
    padding: 30,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  divider: {
    height: "12px",
  },
  textField: {
    width: "100%",
  },
};

export default styles;

